module.exports = __webpack_public_path__ + "static/img/whatsapp.6c54bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/social-media/whatsapp.png
// module id = sOs2
// module chunks = 1